import { RouteConfig } from "vue-router";

export const REmployerEmployeesTemplateSummary: RouteConfig = {
  path: "summary",
  name: "EmployerEmployeesTemplateSummary",
  component: () =>
    import(
      /* webpackChunkName: "employer-employees-template-summary" */
      "./VEmployerEmployeesTemplateSummary.vue"
    ),
  meta: {
    title: "Employees",
    label: "summary",
  },
};
